import {v4 as uuid} from "uuid";
import {NodeFileSearchControl, LabelNumberTextControl, SearchControl} from "../../controls";
import {RemoveButtonControl} from "../../controls/RemoveButtonControl";
import {SequenceComponentHelper} from "../../extensions/SequenceComponentHelper";
import Rete from "rete";
import {tempActionSocket} from "../../sockets";
import {SequenceComponent} from "../SequenceComponent";
import {NodeFileType} from "models/NodeFileType";

export class Video {

    constructor(parentComponent, videoAdded, videoRemoved) {
        this.parentComponent = parentComponent;
        this.onVideoAdded = videoAdded;
        this.onVideoRemoved = videoRemoved;
        this.isAdded = false;
    }

    addVideo(node, videoUUID = null) {
        if (videoUUID == null) {
            videoUUID = uuid();
        }

        const videoFileControl = new NodeFileSearchControl(
            this.parentComponent.editor,
            SequenceComponentHelper.getVideoFileKey(videoUUID),
            node,
            NodeFileType.Video,
            false,
            "Video file"
        );

        const videoMappingOptions = [
            { value: 'normal', label: 'normal' },
            { value: '180', label: '180' },
            { value: '360', label: '360' }
        ];
        const videoMappingSearchControl = new SearchControl(
            this.parentComponent.editor,
            SequenceComponentHelper.getVideoMappingKey(videoUUID),
            node,
            false,
            "Video mapping",
            videoMappingOptions,
            videoMappingOptions[0].value
        );

        const stereoModeOptions = [
            { value: 'none', label: 'none' },
            { value: 'left-right', label: 'left-right' },
            { value: 'top-bottom', label: 'top-bottom' }
        ];
        const stereoModeSearchControl = new SearchControl(
            this.parentComponent.editor,
            SequenceComponentHelper.getVideoStereoModeKey(videoUUID),
            node,
            false,
            "Stereo mode",
            stereoModeOptions,
            stereoModeOptions[0].value
        );

        const startTimeControl = new LabelNumberTextControl(
            this.parentComponent.editor,
            SequenceComponentHelper.getVideoStartFrameKey(videoUUID),
            node,
            false,
            "Start frame"
        );

        const stopTimeControl = new LabelNumberTextControl(
            this.parentComponent.editor,
            SequenceComponentHelper.getVideoStopFrameKey(videoUUID),
            node,
            false,
            "Stop frame"
        );

        const output = new Rete.Output(
            SequenceComponentHelper.getVideoOutputKey(videoUUID),
            "Action",
            tempActionSocket,
            false
        );

        const removeVideoControl = new RemoveButtonControl(
            this.parentComponent.editor,
            SequenceComponentHelper.getVideoRemoveButtonKey(videoUUID),
            node,
            false,
            () => this.onRemoveVideoClick.bind(this, node, videoUUID, removeVideoControl, videoFileControl, videoMappingSearchControl, stereoModeSearchControl, startTimeControl, stopTimeControl, output)
        );

        node
            .addControl(removeVideoControl)
            .addControl(videoFileControl)
            .addControl(videoMappingSearchControl)
            .addControl(stereoModeSearchControl)
            .addControl(startTimeControl)
            .addControl(stopTimeControl)
            .addOutput(output);

        this.videoAdded(node, videoUUID);
        node.update();
    }

    videoAdded(node, addedVideoUUID) {
        node.videoId = addedVideoUUID;
        this.isAdded = true;
        this.onVideoAdded();
    }

    onRemoveVideoClick(node, videoUUID,  removeVideoControl, videoFileControl, videoMappingSearchControl, stereoModeSearchControl, startTimeControl, stopTimeControl, outputControl) {
        this.removeVideo(node, videoUUID,  removeVideoControl, videoFileControl, videoMappingSearchControl, stereoModeSearchControl, startTimeControl, stopTimeControl, outputControl)
            .then(r => {
                this.videoRemoved(node, videoUUID);
            });
    }

    async removeVideo(node, videoUUID,  removeVideoControl, videoFileControl, videoMappingSearchControl, stereoModeSearchControl, startTimeControl, stopTimeControl, outputControl) {
        node.removeControl(removeVideoControl);
        node.removeControl(videoFileControl);
        node.removeControl(videoMappingSearchControl);
        node.removeControl(stereoModeSearchControl);
        node.removeControl(startTimeControl);
        node.removeControl(stopTimeControl);

        outputControl.connections.map(connection => this.parentComponent.editor.removeConnection(connection));
        node.removeOutput(outputControl);

        node.update();

        this.parentComponent.editor.view.updateConnections({node});

        delete node.data[SequenceComponentHelper.getVideoFileKey(videoUUID)];
        delete node.data[SequenceComponentHelper.getVideoMappingKey(videoUUID)];
        delete node.data[SequenceComponentHelper.getVideoStereoModeKey(videoUUID)];
        delete node.data[SequenceComponentHelper.getVideoStartFrameKey(videoUUID)];
        delete node.data[SequenceComponentHelper.getVideoStopFrameKey(videoUUID)];
    }

    async videoRemoved(node, videoUUID) {
        node.videoId = null;
        this.isAdded = false;
        this.onVideoRemoved();
    }

    handleAnswerAdded(node) {
        if (!this.isAdded) return;

        let videoOutputControl = null;
        node.outputs.forEach(output => {
            const outputKey = output.key.split('_');
            if (outputKey[1] === SequenceComponent.VIDEO_CHILD_COMPONENT_KEY) {
                if (videoOutputControl) throw new Error("Video component cannot handle multiple outputs.");
                videoOutputControl = output;
            }
        });

        if (videoOutputControl.connections.length > 0) {
            videoOutputControl.connections.map(connection => this.parentComponent.editor.removeConnection(connection));
            node.update();
            this.parentComponent.editor.view.updateConnections({node});
        }
    }

    handleAnswerRemoved(node) {
        if (!this.isAdded) return;
        node.update();
    }
}